var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16634 0.875C0.844175 0.875 0.583008 1.13617 0.583008 1.45833V8.80014C0.583008 9.1223 0.844175 9.38347 1.16634 9.38347C1.48851 9.38347 1.74967 9.1223 1.74967 8.80014V5.54167H12.2497V11.9583H3.79589C3.47372 11.9583 3.21256 12.2195 3.21256 12.5417C3.21256 12.8638 3.47372 13.125 3.79589 13.125H12.833C13.1552 13.125 13.4164 12.8638 13.4164 12.5417C13.4164 12.5002 13.412 12.4598 13.4038 12.4208C13.412 12.3819 13.4163 12.3415 13.4163 12.3001V1.45833C13.4163 1.13617 13.1552 0.875 12.833 0.875H1.16634ZM9.38968 7.45731C9.1612 7.23457 8.79616 7.23674 8.57034 7.46218L6.62804 9.4013L5.12102 7.95808C4.89106 7.73785 4.52697 7.74271 4.30297 7.96902L0.751758 11.5567C0.52512 11.7857 0.527009 12.1551 0.755978 12.3817C0.984946 12.6083 1.35429 12.6064 1.58092 12.3775L4.72849 9.19754L6.23305 10.6384C6.46205 10.8577 6.82428 10.8539 7.04866 10.6299L8.98735 8.69442L9.88209 9.56669C10.1128 9.79158 10.4821 9.78689 10.707 9.5562C10.9319 9.32552 10.9272 8.9562 10.6965 8.73131L9.38968 7.45731ZM12.2498 2.1875H1.74982V4.375H12.2498V2.1875Z",
    fill: "#80878C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingIcon);
export default __webpack_public_path__ + "static/media/ranking-icon.3f0409587284aef8a471b46bb9176ff0.svg";
export { ForwardRef as ReactComponent };